export default __webpack_public_path__ + "static/media/D100_17A100C.0d7eaa7a.STEP";